import { Button } from '@/components/buttons';
import { FacebookLogin } from '@/widgets/Facebook';
import {
  ButtonWrapper,
  Container,
  ContentWrapper,
  Square,
  SquareCarousel,
  Title,
} from './MoreGroupsUnauthenticated.styles';

function MoreGroupsUnauthenticated({
  onClickToContinueWithEmail,
}: {
  onClickToContinueWithEmail: () => void;
}): JSX.Element {
  return (
    <>
      <Container>
        <ContentWrapper>
          <Title>
            Access a community of people like you who are there to listen, offer
            valuable tips and share their tricks.
          </Title>

          <ButtonWrapper>
            {/* <FacebookLogin /> */}
            <Button onClick={onClickToContinueWithEmail}>
              Continue with email
            </Button>
          </ButtonWrapper>
        </ContentWrapper>
        <Square />
        <SquareCarousel />
        <SquareCarousel />
      </Container>
    </>
  );
}

export default MoreGroupsUnauthenticated;
